import Client from './client';

export default class ViesResults extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(options = {}) {
    return this.makeRequest(`${this.host}/tax/registration`, options);
  }

  getByNumber(number, options = {}) {
    return this.makeRequest(`${this.host}/tax/registration/${number}`, options);
  }

}
